import { render, staticRenderFns } from "./RoleDetailsForm.vue?vue&type=template&id=daedb22c"
import script from "./RoleDetailsForm.vue?vue&type=script&lang=js"
export * from "./RoleDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports